module.exports = __webpack_public_path__ + "img/bg_score_02.411b1d92.jpg";